export default __webpack_public_path__ + "media/images/paylogos/color/visa_verified-7a9e6a6f14e15ded5113957a21e715e4.png";